import { useEffect } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  ogImage?: string;
  path?: string;
}

const BASE_URL = 'https://sign.gelovo.dev';

const defaults = {
  title: 'Gelovo Sign — חתימה דיגיטלית מאובטחת על מסמכי PDF',
  description:
    'Gelovo Sign — פלטפורמת חתימה דיגיטלית בעברית לעסקים בישראל. שליחת מסמכי PDF לחתימה במייל וב-SMS, שדות חותם דינמיים, תעודת ביקורת ושמירה מאובטחת בענן.',
  ogImage: '/og-image.png',
};

export function SEOHead({
  title = defaults.title,
  description = defaults.description,
  ogImage = defaults.ogImage,
  path = '',
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const fullImageUrl = ogImage.startsWith('http') ? ogImage : `${BASE_URL}${ogImage}`;
    const fullUrl = `${BASE_URL}${path}`;

    const setMeta = (attr: string, key: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const setCanonical = (href: string) => {
      let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', 'canonical');
        document.head.appendChild(el);
      }
      el.setAttribute('href', href);
    };

    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:image', fullImageUrl);
    setMeta('property', 'og:url', fullUrl);
    setMeta('property', 'og:type', 'website');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', fullImageUrl);
    setCanonical(fullUrl);

    return () => {
      document.title = defaults.title;
      setMeta('name', 'description', defaults.description);
      setMeta('property', 'og:title', defaults.title);
      setMeta('property', 'og:description', defaults.description);
      setMeta('property', 'og:image', `${BASE_URL}${defaults.ogImage}`);
      setMeta('property', 'og:url', `${BASE_URL}/`);
      setMeta('name', 'twitter:title', defaults.title);
      setMeta('name', 'twitter:description', defaults.description);
      setMeta('name', 'twitter:image', `${BASE_URL}${defaults.ogImage}`);
      setCanonical(`${BASE_URL}/`);
    };
  }, [title, description, ogImage, path]);

  return null;
}
